import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import {
  FaWhatsapp,
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaEnvelope,
  FaPhoneAlt,
  FaChartBar,
  FaArrowRight,
  FaBolt,
  FaChartLine,
  FaDatabase,
  FaEye,
  FaShieldAlt,
  FaInfoCircle,
} from "react-icons/fa";

// ======= BENEFICIOS DE SUSCRIBIRSE =======
const beneficios = [
  {
    icono: <FaChartLine />,
    titulo: "Análisis en tiempo real",
    descripcion:
      "Acceso a visualizaciones actualizadas con datos del sector energético nacional.",
  },
  {
    icono: <FaDatabase />,
    titulo: "Información consolidada",
    descripcion:
      "Variables del mercado mayorista, precios, demanda y generación en un solo lugar.",
  },
  {
    icono: <FaEye />,
    titulo: "Visibilidad estratégica",
    descripcion:
      "Indicadores clave que facilitan la toma de decisiones basadas en evidencia.",
  },
  {
    icono: <FaShieldAlt />,
    titulo: "Fuentes verificadas",
    descripcion:
      "Información proveniente de fuentes oficiales y metodologías validadas.",
  },
];

export default function InformacionGratuitaForm() {
  const [estaLogueado, setEstaLogueado] = useState(false);
  const navigate = useNavigate();

  // Verificar si hay sesión activa
  useEffect(() => {
    const token = localStorage.getItem("token");
    setEstaLogueado(!!token);
  }, []);

  const irARegistro = () => {
    navigate("/register");
  };

  // ✅ URL del Power BI público (reemplazar por la propia cuando esté lista)
  const POWERBI_EMBED_URL =
    "https://app.powerbi.com/view?r=eyJrIjoiZGRhMzhjOWUtZTRlYi00MTgwLTk1ODItODQ1ZmU2YzU3NTRiIiwidCI6IjI4MDQyNjJjLTI5NjUtNDFiYi1iMTRkLTJjODg5ZTAyZDM3OSIsImMiOjN9";

  return (
    <div className="min-h-screen bg-[#1f1b24] text-white font-nexa font-normal flex flex-col">
      {/* ======= NAVBAR ======= */}
      <Navbar />

      {/* ======= HERO ======= */}
      <section className="relative w-full overflow-hidden py-16 md:py-20">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1f1b24] via-[#2a2533] to-[#1f1b24]"></div>
        <div className="absolute top-10 right-10 w-96 h-96 bg-[#00b3b3]/20 rounded-full blur-[120px] animate-pulse"></div>
        <div
          className="absolute bottom-10 left-10 w-96 h-96 bg-[#00e68a]/20 rounded-full blur-[120px] animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <div className="inline-flex items-center gap-2 bg-[#00e68a]/20 border border-[#00e68a] text-[#00e68a] px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <FaChartBar />
            <span>Información gratuita</span>
          </div>

          <h1 className="font-elianto text-4xl md:text-6xl uppercase tracking-wider text-white leading-tight drop-shadow-[0_0_15px_rgba(0,230,138,0.5)] mb-6">
            Datos del sector
            <br />
            <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
              al alcance
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 max-w-3xl leading-relaxed">
            QuarkIA pone a disposición un tablero interactivo con información
            relevante del sector energético colombiano. La consulta es gratuita
            para todos los visitantes.
          </p>
        </div>
      </section>

      {/* ======= DASHBOARD POWER BI ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-12">
        <div className="bg-[#2c2833] rounded-2xl shadow-lg border border-white/10 overflow-hidden">
          <div className="p-6 md:p-8 border-b border-white/10">
            <h2 className="text-xl md:text-2xl font-semibold text-[#00e68a]">
               Dashboard interactivo
            </h2>
            <p className="text-gray-300">
              Visualización integrada directamente desde fuentes oficiales del sector energético.
            </p>
          </div>

          <div className="p-3 md:p-4">
            <div className="relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black/20">
              {/* ✅ 16:9 responsive */}
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  title="PowerBI Report"
                  src={POWERBI_EMBED_URL}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>

            <p className="mt-3 px-2 text-xs text-gray-400">
              Dashboard inteligente para acceder a análisis del sector energético.
            </p>
          </div>
        </div>

        {/* Nota informativa */}
        <div className="mt-6 bg-[#2a2533] border border-white/5 rounded-2xl p-5 flex items-start gap-3">
          <FaInfoCircle className="text-[#00e68a] text-xl mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-white font-semibold mb-1">Sobre este tablero</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              La información presentada proviene de fuentes oficiales del
              sector energético y se actualiza periódicamente. Para acceder a
              análisis más detallados y reportes personalizados, es posible
              contactar al equipo comercial de QuarkIA.
            </p>
          </div>
        </div>
      </section>

      {/* ======= BENEFICIOS ======= */}
      <section className="max-w-7xl mx-auto w-full px-6 md:px-12 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#00b3b3]/20 border border-[#00b3b3] text-[#00b3b3] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaBolt />
            <span>¿Qué ofrece el tablero?</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            Información que{" "}
            <span className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] bg-clip-text text-transparent">
              marca la diferencia
            </span>
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            El tablero reúne las variables más relevantes del sector energético
            colombiano en un espacio visual, interactivo y confiable.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {beneficios.map((b, i) => (
            <div
              key={i}
              className="bg-[#2a2533] rounded-2xl p-6 border border-white/5 hover:border-[#00e68a]/40 hover:-translate-y-2 transition-all duration-300 group"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#00b3b3] to-[#00e68a] flex items-center justify-center text-2xl text-[#1f1b24] mb-4 shadow-lg group-hover:scale-110 transition-transform">
                {b.icono}
              </div>
              <h3 className="text-lg font-bold text-white mb-2 group-hover:text-[#00e68a] transition-colors">
                {b.titulo}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                {b.descripcion}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ======= CTA FINAL (solo si no está logueado) ======= */}
      {!estaLogueado && (
        <section className="max-w-7xl mx-auto w-full px-6 md:px-12 pb-20">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#00b3b3] to-[#00e68a] p-10 md:p-14 shadow-2xl">
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>

            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-[#1f1b24] text-center md:text-left">
                <h3 className="text-2xl md:text-3xl font-extrabold mb-2">
                  Dashboards avanzados con la suscripción
                </h3>
                <p className="text-[#1f1b24]/80 text-base md:text-lg max-w-xl">
                  El registro toma menos de un minuto y abre la puerta a
                  análisis avanzados, proyecciones y reportes personalizados
                  del sector energético.
                </p>
              </div>
              <button
                onClick={irARegistro}
                className="bg-[#1f1b24] text-white font-bold px-8 py-4 rounded-xl hover:scale-105 transition-transform whitespace-nowrap flex items-center gap-2 shadow-xl"
              >
                Suscribite gratis <FaArrowRight />
              </button>
            </div>
          </div>
        </section>
      )}

      {/* ======= FOOTER ======= */}
      <footer className="bg-[#16131a] py-8 text-center border-t border-gray-700 mt-auto">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex space-x-6 text-2xl text-[#00b3b3]">
            <a
              href="https://wa.me/573001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00ff80] transition"
            >
              <FaFacebook />
            </a>
          </div>

          <div className="flex flex-col items-center text-sm md:text-base space-y-2">
            <p className="flex items-center space-x-2">
              <FaEnvelope className="text-[#00b3b3]" />
              <span>info@quarkia.com.co</span>
            </p>
            <p className="flex items-center space-x-2">
              <FaPhoneAlt className="text-[#00b3b3]" />
              <span>+57 311 383 6855</span>
            </p>
          </div>

          <p className="text-gray-400 text-xs mt-4">
            © {new Date().getFullYear()} QuarkIA S.A.S. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
